export default __webpack_public_path__ + "static/media/Servicios.b2cb93e9.svg";